import React, {useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import httpHelper, {Method_TYPE}  from 'utils/http-helper';
import URL_CONSTANTS from 'constants/url-constants';

const DashboardStatusCards = () => {

  const navigate = useNavigate();

  const [statusCards,setStatusCards] = useState([
    {
      title: 'Total Required',
      key :"total_required",
      count: 0,
      description: 'Total sevadal needed for this service',
      icon: 'ClipboardList',
      color: 'warning',
      path: '/dashboard',
    },
    {
      title: 'Allocated Members',
      key :"allocated",
      count: 0,
      description: 'Members assigned to seva',
      icon: 'Users',
      color: 'success',
      path: '/allocated-members-management',
    },
    {
      title: 'Unallocated Members',
      key :"unallocated",
      count: 0,
      description: 'Members pending assignment',
      icon: 'UserX',
      color: 'error',
      path: '/unallocated-members-management',
    },
    {
      title: 'Shortfall',
      key :"required",
      count: 0,
      description: 'Services awaiting allocation',
      icon: 'ClipboardList',
      color: 'warning',
      path: '/required-services-management',
    }
  ]);

  useEffect(() => {
        
    const fetchData = async () => {

      try {

        const data = await httpHelper(URL_CONSTANTS.CURRENT_BATCH, Method_TYPE.GET);

        const stats = await httpHelper(`${URL_CONSTANTS.STATS}/${data._id.toString()}/stats`, Method_TYPE.GET);

        const updatedCards = [...statusCards]; // Create a copy of statusCards

        var totalCount = 0;

        Object.keys(stats).forEach(key => {

          const card = updatedCards.find(card => card.key === key);
        
          if (card) {
            card.count = stats[key];
            totalCount = totalCount + stats[key];
          }
        });

        const totalRequiredCard = updatedCards.find(card => card.key === 'total_required');
        console.log("totalCount", totalCount);
        if (totalRequiredCard) {
          totalRequiredCard.count = totalCount;
        }

        setStatusCards(updatedCards); // Update the state with the new counts

      } catch (error) {

        console.error('Error fetching data:', error);

      }
    };

       fetchData(); // Initial fetch
       
        const intervalId = setInterval(fetchData, 5000); // Fetch every 5 seconds

        return () => clearInterval(intervalId); // Cleanup on unmount

  }, []);



  const getCardStyles = (color) => {
    const styles = {
      success: {
        bg: 'bg-success/5',
        border: 'border-success/20',
        icon: 'text-success',
        count: 'text-success'
      },
      warning: {
        bg: 'bg-warning/5',
        border: 'border-warning/20',
        icon: 'text-warning',
        count: 'text-warning'
      },
      error: {
        bg: 'bg-error/5',
        border: 'border-error/20',
        icon: 'text-error',
        count: 'text-error'
      }
    };
    return styles[color] || styles.success;
  };



  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {statusCards.map((card) => {
        const cardStyles = getCardStyles(card.color);
        
        return (
          <div
            key={card.path}
            className={`
              ${cardStyles.bg} ${cardStyles.border}
              bg-card border rounded-lg p-6 pb-3
              hover:shadow-spiritual-md transition-all duration-300 
              cursor-pointer group
            `}
            onClick={() => navigate(card.path)}
          >
            {/* <div className="flex items-start justify-between mb-4">
              <div className={`
                w-12 h-12 rounded-lg flex items-center justify-center
                ${cardStyles.bg} ${cardStyles.border}
                group-hover:scale-105 transition-transform duration-200
              `}>
                
              </div>
              
             
            </div> */}

            <div className="space-y-2 flex justify-between">
              <div>
                <div className="flex items-baseline space-x-2">
                <h3 className={`text-3xl font-heading font-semibold mb-2 ${cardStyles.count}`}>
                  {card.count}
                </h3>
                <span className="text-xs text-muted-foreground font-caption">
                  {card.trend}
                </span>
              </div>
              
              <h4 className="font-heading font-medium text-foreground">
                {card.title}
              </h4>
              
              <p className="text-sm text-muted-foreground">
                {card.description}
              </p>
              </div>
              <div>
                <Icon 
                  name={card.icon} 
                  size={24} 
                  className={cardStyles.icon}
                />
              </div>
            </div>

            <div className="mt-4 pt-4 border-t border-border/50">
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span>Click to manage</span>
                 <Button
                variant="ghost"
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(card.path);
                }}
                className="opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <Icon name="ArrowRight" size={16} />
              </Button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DashboardStatusCards;